
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {rules} from "@/auxillary/rules";
import {currentUserModule, rolesModule} from "@/store";
import DataFieldCache from "@/models/data.field.cache";
import {MdbsCore} from "@/api/tsclient";
import EventReportClient = MdbsCore.EventReportClient;
import EventReportSignatureDto = MdbsCore.EventReportSignatureDto;

@Component({})
export default class EventReportSignatureDialog extends Vue {
  @Prop({required: true})
  eventReportField: DataFieldCache | null;

  @Prop({required: true})
  dialogVisible: boolean | null;

  private reason = "Ich bestätige hiermit die Richtigkeit der Daten.";
  private userName = "";
  private password = "";

  message = "";

  saving = false;
  valid: boolean = false;
  rules: any = rules;

  get loading() {
    return false;
  }

  @Watch('eventReportField', {immediate: true})
  async onVisitChange(eventReportField: DataFieldCache | null) {
    if (eventReportField == null) {
      return;
    }

    Vue.nextTick(() => {
      this.form?.validate();
    });
  }

  @Watch('dialogVisible', {immediate: true})
  async onDialogVisibleChange(visible: boolean) {
    if (!visible) return;

    this.message = "";

    await this.prePopulateUserName();
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  async save() {
    if (!this.eventReportField) return;

    try {
      this.saving = true;

      const erClient = new EventReportClient()
      const result =  await erClient.signEventReport(this.eventReportField.id, new EventReportSignatureDto({
        userName: this.userName,
        password: this.password,
        reason: this.reason
      }))

      if (result.success){
        this.$emit('save');
      } else {
        this.message = result.message ?? "";
      }

    } finally {
      this.saving = false;
      this.userName = "";
      this.password = "";
    }
  }

  async cancel() {
    this.$emit('cancel');
    this.userName = "";
    this.password = "";
  }

  get currentUser() {
    return currentUserModule.user;
  }

  async mounted() {
  }

  private async prePopulateUserName() {
    const user = this.currentUser;
    if (user?.role?.id == null || user?.userName == null) return;

    if(currentUserModule.isNtdUser)
      return;

    const role = await rolesModule.getRoleById(user.role.id);

    if (role?.identifier?.toLowerCase() == "physician") {
      this.userName = user.userName;
    }
  }
}
